module.exports = __webpack_public_path__ + "static/media/meth-1.1d00733d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meth-1.jpg
// module id = 1051
// module chunks = 0